<style lang="scss" scoped>
    .expanded{
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.16);
        padding-bottom: 20px !important;
    }
    .beat-discount-container {
        display: flex;
        flex-direction: column;
        text-align: center;
        justify-content: space-between;
        position: relative;
        box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
        border-radius: 5px;
        padding: 0;
        background-clip: padding-box;
        color: #363c43;
        transition: .4s ease;

        .license-name {
            font-size: 16px;
            font-weight: 600;
            text-transform: uppercase;
        }
       
        .discount{
            font-family: Poppins;
            font-size: 12px;
            font-weight: 400;
            text-align: center;
            margin: 5px 0 0px;

        }

        .license-files {
            font-family: Poppins;
            font-size: 12px;
            font-weight: 500;
        }
        
        .expand-button {
            position: absolute;
            bottom: -20px;
            left: 50%;
            transform: translateX(-50%);
            cursor: pointer;
            color: #fff !important;
            width: 80%;
            box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
            border-radius: 5px;
            background-color: #8f40b0;
            padding: 8px;
            font-size: 15px;
            font-weight: 500;
        }

        .price{
            color: #e15498;
            font-family: Poppins;
            font-size: 23px;
            font-weight: 600;
            text-align: center;
            margin: 0px 0 5px;
        }

        .view-more-target{
            display: none;
            transition: display .2s ease;
        }

        .view-less-target{
            display: block;
            transition: display .2s ease;
        }
    }
    .discount-icon-container{
        margin-bottom: 15px;
        border-bottom: 1px solid rgba(89, 94, 99, 0.1);
        height: 50px;
        position: relative;

        .discount-license-img{
            width: 40px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }

</style>

<template>
    <div class="beat-discount-container" :class="{'expanded' : expanded}" @mouseover="hover(true)" @mouseleave="hover(false)" :style="$discountContainerStyle">
        <div>
            <div class="discount-icon-container">
                <license-icon class="discount-license-img" :size="imgIndex" :highlighted-license="false"></license-icon>
            </div>
            <div>
                <div class="license-name" :style="$highlightColor">{{price.name}}</div>
            </div>
            <div  v-for="(discount , index) in price.discounts" :key="index" :class="{'view-more-target': index > 0 , 'view-less-target' : expanded}" >
                <div class="discount">{{ discount.quantity }} beats for </div>
                <div class="price" :style="$highlightColor">{{ discount.price | displayPrice }}</div>
            </div>
        </div>
        <a class="expand-button" @click="showMore" v-if="price.discounts.length > 1" :style="$licenseDiscountsButtonStyle(false)">
            <span v-if="expanded">
                View less
            </span>
            <span v-else>
                View More
            </span>
        </a>
    </div>
</template>

<script>
    import Configure from './../mixins/configure'
    import LicenseIcon from './licenses/licenseicon.vue'

    export default {
        props: {
            price: Object,
            imgIndex: ''
        },
        components: {
            LicenseIcon
        },
        data() {
            return {
                expanded : false
            }
        },
        mixins: [Configure],
        methods: {
            hover(isHovering) {
                this.$data.$hover.discountContainer = isHovering
            },
            showMore() {
                this.expanded = !this.expanded
                // this.$data.$active.discountContainer = this.expanded
            }
        }
    }
</script>
